import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserProfile, updateUserProfile } from '../lib/services/ProfileService';
// Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
// import { uploadAvatar, deleteAvatar, getAvatarUrl } from '../lib/services/StorageService';
import { User, Mail, Lock, Save, AlertCircle, CheckCircle2, Camera, X } from 'lucide-react';
// Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
// Les icônes Camera et X sont importées mais la section est masquée

const ProfileManagement: React.FC = () => {
  const { user, updatePassword } = useAuth();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  // États pour le profil
  const [email, setEmail] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newNom, setNewNom] = useState('');
  const [newPrenom, setNewPrenom] = useState('');
  // Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
  // const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  // const [uploadingAvatar, setUploadingAvatar] = useState(false);
  // const fileInputRef = useRef<HTMLInputElement>(null);
  const [avatarUrl] = useState<string | null>(null);
  const [uploadingAvatar] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // États pour le mot de passe
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [changingPassword, setChangingPassword] = useState(false);

  // Charger le profil au montage
  useEffect(() => {
    loadProfile();
  }, [user]);

  const loadProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error: profileError } = await getUserProfile();

      if (profileError) {
        setError('Erreur lors du chargement du profil');
        return;
      }

      if (data) {
        setEmail(data.email || user?.email || '');
        setNom(data.nom || '');
        setPrenom(data.prenom || '');
        setNewEmail(data.email || user?.email || '');
        setNewNom(data.nom || '');
        setNewPrenom(data.prenom || '');
        
        // Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
        // Charger l'URL de l'avatar
        // if (data.avatar_url) {
        //   setAvatarUrl(data.avatar_url);
        // } else {
        //   // Essayer de récupérer l'avatar depuis Storage
        //   const storageUrl = await getAvatarUrl();
        //   if (storageUrl) {
        //     setAvatarUrl(storageUrl);
        //     // Mettre à jour le profil avec l'URL si elle n'existe pas
        //     await updateUserProfile({ avatar_url: storageUrl });
        //   }
        // }
      }
    } catch (err) {
      console.error('Erreur lors du chargement du profil:', err);
      setError('Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveProfile = async () => {
    try {
      setSaving(true);
      setError(null);
      setSuccess(null);

      // Vérifier si des modifications ont été faites
      const updates: { email?: string; nom?: string; prenom?: string } = {};

      if (newEmail && newEmail !== email) {
        updates.email = newEmail;
      }

      if (newNom !== nom) {
        updates.nom = newNom || null;
      }

      if (newPrenom !== prenom) {
        updates.prenom = newPrenom || null;
      }

      if (Object.keys(updates).length === 0) {
        setSuccess('Aucune modification à enregistrer');
        return;
      }

      const { data, error: updateError } = await updateUserProfile(updates);

      if (updateError) {
        setError(updateError.message || 'Erreur lors de la mise à jour du profil');
        return;
      }

      // Mettre à jour les valeurs affichées
      if (data) {
        setEmail(data.email || '');
        setNom(data.nom || '');
        setPrenom(data.prenom || '');
        if (data.avatar_url) {
          setAvatarUrl(data.avatar_url);
        }
      }

      setSuccess('Profil mis à jour avec succès');
      
      // Réinitialiser les champs de modification
      setNewEmail(data?.email || user?.email || '');
      setNewNom(data?.nom || '');
      setNewPrenom(data?.prenom || '');
    } catch (err: any) {
      console.error('Erreur lors de la sauvegarde:', err);
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = async () => {
    try {
      setChangingPassword(true);
      setError(null);
      setSuccess(null);

      // Validation
      if (!newPassword || !confirmPassword) {
        setError('Veuillez remplir tous les champs');
        return;
      }

      if (newPassword.length < 6) {
        setError('Le mot de passe doit contenir au moins 6 caractères');
        return;
      }

      if (newPassword !== confirmPassword) {
        setError('Les mots de passe ne correspondent pas');
        return;
      }

      await updatePassword(newPassword);

      setSuccess('Mot de passe modifié avec succès');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err: any) {
      setError(err.message || 'Erreur lors de la modification du mot de passe');
    } finally {
      setChangingPassword(false);
    }
  };

  // Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
  const handleAvatarClick = () => {
    // fileInputRef.current?.click();
    console.log('Upload de photo temporairement désactivé');
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    // Temporairement désactivé
    return;
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploadingAvatar(true);
      setError(null);
      setSuccess(null);

      // Uploader l'image
      const { data: uploadedUrl, error: uploadError } = await uploadAvatar(file);

      if (uploadError) {
        setError(uploadError);
        return;
      }

      if (!uploadedUrl) {
        setError('Erreur lors de l\'upload de l\'image');
        return;
      }

      // Mettre à jour le profil avec l'URL de l'avatar
      const { error: updateError } = await updateUserProfile({ avatar_url: uploadedUrl });
      
      if (updateError) {
        // Même si la mise à jour du profil échoue, on garde l'URL
        console.warn('Erreur lors de la mise à jour du profil:', updateError);
      }

      setAvatarUrl(uploadedUrl);
      
      setSuccess('Photo de profil mise à jour avec succès');
    } catch (err: any) {
      console.error('Erreur lors de l\'upload:', err);
      setError(err.message || 'Erreur lors de l\'upload de l\'image');
    } finally {
      setUploadingAvatar(false);
      // Réinitialiser l'input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  // Temporairement désactivé - TODO: Réactiver une fois le problème Storage résolu
  const handleDeleteAvatar = async () => {
    // Temporairement désactivé
    console.log('Suppression de photo temporairement désactivée');
    return;
    // if (!window.confirm('Voulez-vous vraiment supprimer votre photo de profil ?')) {
    //   return;
    // }

    try {
      setUploadingAvatar(true);
      setError(null);

      const { error: deleteError } = await deleteAvatar();

      if (deleteError) {
        setError(deleteError);
        return;
      }

      // Mettre à jour le profil pour supprimer l'URL
      await updateUserProfile({ avatar_url: null });
      
      setAvatarUrl(null);
      setSuccess('Photo de profil supprimée avec succès');
    } catch (err: any) {
      console.error('Erreur lors de la suppression:', err);
      setError(err.message || 'Erreur lors de la suppression de l\'image');
    } finally {
      setUploadingAvatar(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
          <p className="text-white text-sm mt-3">Chargement du profil...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Messages d'erreur et de succès */}
      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 flex items-center space-x-2">
          <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0" />
          <span className="text-red-400 text-sm">{error}</span>
        </div>
      )}

      {success && (
        <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4 flex items-center space-x-2">
          <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" />
          <span className="text-green-400 text-sm">{success}</span>
        </div>
      )}

      {/* Section Photo de profil - TEMPORAIREMENT MASQUÉE */}
      {/* TODO: Réactiver une fois le problème Storage résolu */}
      {false && (
      <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
            <Camera className="w-5 h-5 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">Photo de profil</h2>
            <p className="text-dark-400 text-sm">Modifiez votre photo de profil</p>
          </div>
        </div>

        <div className="flex flex-col items-center space-y-4">
          {/* Avatar */}
          <div className="relative">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt="Photo de profil"
                className="w-32 h-32 rounded-full object-cover border-4 border-dark-700"
              />
            ) : (
              <div className="w-32 h-32 rounded-full bg-dark-700 border-4 border-dark-600 flex items-center justify-center">
                <User className="w-16 h-16 text-dark-400" />
              </div>
            )}
            
            {/* Overlay avec boutons */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-full opacity-0 hover:opacity-100 transition-opacity">
              <div className="flex items-center space-x-2">
                <button
                  onClick={handleAvatarClick}
                  disabled={uploadingAvatar}
                  className="p-2 bg-primary-500 hover:bg-primary-600 text-white rounded-full transition-colors disabled:opacity-50"
                  title="Changer la photo"
                >
                  <Camera className="w-5 h-5" />
                </button>
                {avatarUrl && (
                  <button
                    onClick={handleDeleteAvatar}
                    disabled={uploadingAvatar}
                    className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-full transition-colors disabled:opacity-50"
                    title="Supprimer la photo"
                  >
                    <X className="w-5 h-5" />
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Input file caché */}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={handleFileChange}
            className="hidden"
          />

          {uploadingAvatar && (
            <p className="text-dark-400 text-sm">Upload en cours...</p>
          )}

          <p className="text-dark-400 text-xs text-center max-w-md">
            Formats acceptés : JPEG, PNG, WebP, GIF. Taille maximale : 5 MB
          </p>
        </div>
      </div>
      )}

      {/* Section Profil */}
      <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
            <User className="w-5 h-5 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">Informations personnelles</h2>
            <p className="text-dark-400 text-sm">Modifiez vos informations de profil</p>
          </div>
        </div>

        <div className="space-y-4">
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-dark-300 mb-2">
              <Mail className="w-4 h-4 inline mr-2" />
              Adresse email
            </label>
            <div className="space-y-2">
              <input
                type="email"
                value={email}
                disabled
                className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-dark-400 cursor-not-allowed"
              />
              <input
                type="email"
                placeholder="Nouvel email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                className="w-full px-4 py-2 bg-dark-800 border border-dark-600 rounded-lg text-white placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
          </div>

          {/* Nom */}
          <div>
            <label className="block text-sm font-medium text-dark-300 mb-2">
              Nom
            </label>
            <div className="space-y-2">
              <input
                type="text"
                value={nom || 'Non renseigné'}
                disabled
                className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-dark-400 cursor-not-allowed"
              />
              <input
                type="text"
                placeholder="Nouveau nom"
                value={newNom}
                onChange={(e) => setNewNom(e.target.value)}
                className="w-full px-4 py-2 bg-dark-800 border border-dark-600 rounded-lg text-white placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
          </div>

          {/* Prénom */}
          <div>
            <label className="block text-sm font-medium text-dark-300 mb-2">
              Prénom
            </label>
            <div className="space-y-2">
              <input
                type="text"
                value={prenom || 'Non renseigné'}
                disabled
                className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-dark-400 cursor-not-allowed"
              />
              <input
                type="text"
                placeholder="Nouveau prénom"
                value={newPrenom}
                onChange={(e) => setNewPrenom(e.target.value)}
                className="w-full px-4 py-2 bg-dark-800 border border-dark-600 rounded-lg text-white placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
          </div>

          {/* Bouton de sauvegarde */}
          <button
            onClick={handleSaveProfile}
            disabled={saving}
            className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Save className="w-4 h-4" />
            <span>{saving ? 'Enregistrement...' : 'Enregistrer les modifications'}</span>
          </button>
        </div>
      </div>

      {/* Section Mot de passe */}
      <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-orange-500/20 rounded-full flex items-center justify-center">
            <Lock className="w-5 h-5 text-orange-400" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">Modifier le mot de passe</h2>
            <p className="text-dark-400 text-sm">Changez votre mot de passe pour sécuriser votre compte</p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-dark-300 mb-2">
              Nouveau mot de passe
            </label>
            <input
              type="password"
              placeholder="Entrez votre nouveau mot de passe"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-2 bg-dark-800 border border-dark-600 rounded-lg text-white placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-dark-300 mb-2">
              Confirmer le mot de passe
            </label>
            <input
              type="password"
              placeholder="Confirmez votre nouveau mot de passe"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-2 bg-dark-800 border border-dark-600 rounded-lg text-white placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
          </div>

          {/* Bouton de modification du mot de passe */}
          <button
            onClick={handleChangePassword}
            disabled={changingPassword || !newPassword || !confirmPassword}
            className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Lock className="w-4 h-4" />
            <span>{changingPassword ? 'Modification...' : 'Modifier le mot de passe'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileManagement;

